import { render, staticRenderFns } from "./exception.vue?vue&type=template&id=3b460326"
import script from "./exception.vue?vue&type=script&lang=js"
export * from "./exception.vue?vue&type=script&lang=js"
import style0 from "./exception.vue?vue&type=style&index=0&id=3b460326&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports